import { type AnchorHTMLAttributes, type MouseEvent, useEffect, useState } from 'react';

export function useLocation() {
  const [location, setLocation] = useState(() => ({ pathname: window.location.pathname, hash: window.location.hash }));
  useEffect(() => {
    const update = () => setLocation({ pathname: window.location.pathname, hash: window.location.hash });
    window.addEventListener('popstate', update);
    window.addEventListener('hashchange', update);
    return () => { window.removeEventListener('popstate', update); window.removeEventListener('hashchange', update); };
  }, []);
  return location;
}

export function Link({ to, onClick, ...props }: AnchorHTMLAttributes<HTMLAnchorElement> & { to: string }) {
  function navigate(event: MouseEvent<HTMLAnchorElement>) {
    onClick?.(event);
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    window.history.pushState({}, '', to);
    window.dispatchEvent(new PopStateEvent('popstate'));
  }
  return <a href={to} onClick={navigate} {...props}/>;
}

export function NavLink({ to, className, ...props }: Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'className'> & { to: string; className?: string | ((state: { isActive: boolean }) => string) }) {
  const { pathname } = useLocation();
  const isActive = to === '/' ? pathname === '/' : pathname === to || pathname.startsWith(`${to}/`);
  return <Link to={to} className={typeof className === 'function' ? className({ isActive }) : className} {...props}/>;
}
